import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import App from './App';

Amplify.configure(awsExports);

const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    respId: params.get('resp_id'),
    userId: params.get('user_id'),
    userName: params.get('user_name'),
    sessionId: params.get('SESSION_ID') || params.get('session_id')
  };
};

const { respId, userId, userName, sessionId } = getQueryParams();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App respId={respId} userId={userId} userName={userName} sessionId={sessionId} />
  </React.StrictMode>
);